import { IApiService } from '../../services/ApiService';
import { LoaderFunctionArgs } from 'react-router';
import { handleLoaderError } from '../../services/loaderErrorHandler';

export function bailleurPageLoader(apiService: IApiService) {
  return async ({ params, request }: LoaderFunctionArgs) => {
    // Fetch bailleur data for breadcrumb display
    if (!params.bailleurId) {
      throw new Error("Invalid id");
    }
    const bailleurId = parseInt(params.bailleurId, 10);
    if (Number.isNaN(bailleurId)) {
      throw new Error("Invalid id");
    }

    // Handle special case: bailleurId = 0 means "hors bailleur"
    if (bailleurId === 0) {
      return { bailleur: null };
    }

    try {
      const bailleur = await apiService.getBailleur(bailleurId, request.signal);
      return { bailleur };
    } catch (error) {
      return handleLoaderError(error, request.url);
    }
  };
}
